// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"368":"bff76f79","3310":"a14cc230","4545":"a14cc230","4800":"e98c8eb3","5036":"9f1c1655","7545":"6a746ecf","8256":"e98c8eb3","8637":"cb0e39d5","8826":"655feead","9095":"a14cc230"}[chunkId] + ".chunk.css";
};